import {
    GET_CREDIT_DEBIT_NOTES,
    GET_CREDIT_DEBIT_NOTE_DETAILS,
    GET_CREDIT_DEBIT_NOTES_BY_INVOICE,
    CREATE_CREDIT_DEBIT_NOTE,
    UPDATE_CREDIT_DEBIT_NOTE,
    POST_CREDIT_DEBIT_NOTE,
    VOID_CREDIT_DEBIT_NOTE,
    DELETE_CREDIT_DEBIT_NOTE,
    CLEAR_CREDIT_DEBIT_NOTE_STATE,
    BULK_UPLOAD_CREDIT_DEBIT_NOTES,
    CLEAR_CREDIT_DEBIT_NOTE_BULK_UPLOAD_STATE,
    BULK_GET_CREDIT_DEBIT_NOTE_DETAILS,
    BULK_POST_CREDIT_DEBIT_NOTES,
    BULK_DELETE_CREDIT_DEBIT_NOTES,
} from '../../index.types';

export function getCreditDebitNotes(data) {
    return { type: GET_CREDIT_DEBIT_NOTES, data }
}

export function getCreditDebitNoteDetails(data) {
    return { type: GET_CREDIT_DEBIT_NOTE_DETAILS, data }
}

export function getCreditDebitNotesByInvoice(data) {
    return { type: GET_CREDIT_DEBIT_NOTES_BY_INVOICE, data }
}

export function createCreditDebitNote(data) {
    return { type: CREATE_CREDIT_DEBIT_NOTE, data }
}

export function updateCreditDebitNote(data) {
    return { type: UPDATE_CREDIT_DEBIT_NOTE, data }
}

export function postCreditDebitNote(data) {
    return { type: POST_CREDIT_DEBIT_NOTE, data }
}

export function voidCreditDebitNote(data) {
    return { type: VOID_CREDIT_DEBIT_NOTE, data }
}

export function deleteCreditDebitNote(data) {
    return { type: DELETE_CREDIT_DEBIT_NOTE, data }
}

export function clearCreditDebitNoteState() {
    return { type: CLEAR_CREDIT_DEBIT_NOTE_STATE }
}

export function bulkUploadCreditDebitNotes(data) {
    return { type: BULK_UPLOAD_CREDIT_DEBIT_NOTES, data }
}

export function clearCreditDebitNoteBulkUploadState() {
    return { type: CLEAR_CREDIT_DEBIT_NOTE_BULK_UPLOAD_STATE }
}

export function bulkGetCreditDebitNoteDetails(data) {
    return { type: BULK_GET_CREDIT_DEBIT_NOTE_DETAILS, data }
}

export function bulkPostCreditDebitNotes(data) {
    return { type: BULK_POST_CREDIT_DEBIT_NOTES, data }
}

export function bulkDeleteCreditDebitNotes(data) {
    return { type: BULK_DELETE_CREDIT_DEBIT_NOTES, data }
}
